import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IPkSetting } from '../models/models'

export class UpdatePkSettingsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/pesineKontrat/updateSettings',
      requesterInfo,
    })
  }

  public async updateSettings(request: IPkSetting): Promise<IPkSetting> {
    return await this.postAsync<IPkSetting>(request)
  }
}
